<template>

    <div>

        <el-form :inline="true" :model="query" class="query-form" size="mini">

            <el-form-item class="query-form-item">
                <el-date-picker
                    v-model="query.time"
                    type="daterange"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    value-format="timestamp"
                    size="small"
                    :default-time="['00:00:00', '23:59:59']">
                </el-date-picker>
            </el-form-item>
            <el-form-item class="query-form-item">
                <el-input v-model="query.name" placeholder="请输入关键字" size="small"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button-group style="height:30px">
                    <el-button type="primary" icon="el-icon-refresh" @click="getList"></el-button>
                    <el-button type="primary" icon="search" @click="onSubmit">查询</el-button>
                    <el-button type="primary"  icon="" @click="reset">重置</el-button>

                </el-button-group>
            </el-form-item>
            <el-button type="primary" size="small" icon="el-icon-plus" @click.native="handleForm(null,null)" style="float:left;  margin-right: 50px;">新增</el-button>
        </el-form>
        <el-table
            tooltip-effect="dark"
            @selection-change="handleSelectionChange"
            v-loading="loading"
            ref="multipleTable"
            :data="list"
            style="width: 100%;"
            :header-cell-style="{background:'#F4F4F5',color:'#606266'}">
            <el-table-column type="selection" width="55" fixed> </el-table-column>
            <el-table-column
                label="消息标题"
                prop="title"
                with="300"
                :show-overflow-tooltip="true"
                fixed>
            </el-table-column>
            <el-table-column
                label="推送类型"
                prop="type"
                with="150"
                :show-overflow-tooltip="true"
                fixed>
                <template slot-scope="scope">
                    <span v-if="scope.row.type == 6">系统消息</span>
                    <span v-if="scope.row.type == 8">文章推送</span>
                    <span v-if="scope.row.type == 10">用户推送</span>
                </template>
            </el-table-column>
            <el-table-column
                label="推Android"
                prop="send_android"
                with="50"
                :show-overflow-tooltip="true"
                fixed>
                <template slot-scope="scope">
                    <span v-if="scope.row.send_android == 0">否</span>
                    <span v-if="scope.row.send_android == 1">是</span>

                </template>
            </el-table-column>
            <el-table-column
                label="推送ID"
                prop="jump_id"
                with="150"
                :show-overflow-tooltip="true"
                fixed>
            </el-table-column>
            <el-table-column
                label="推送状态"
                prop="status"
                with="300"
                :show-overflow-tooltip="true">
                <template slot-scope="scope">
                    <span>{{ scope.row.status | statusFilterType }}</span>
                    <!-- <span v-if="scope.row.status==1">已推送</span>
                    <span v-if="scope.row.status==0">未推送</span> -->
                </template>
            </el-table-column>
            <el-table-column
                    label="推送时间"
                    prop="notification_time"
                    with="300"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    label="添加时间"
                    prop="create_time"
                    with="300"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                    label="内容"
                    style="display:none;"
                    prop="text"
                    with="300"
                    :show-overflow-tooltip="true">
            </el-table-column>
            <el-table-column
                label="操作"
                fixed="right">
                <template slot-scope="scope">
                    <el-button type="text" size="small" @click.native="handleForm(scope.$index, scope.row)">编辑</el-button>
                    <el-button type="text" size="small" @click.native="handleFormSee(scope.$index, scope.row)">查看</el-button>
                    <el-button type="text" size="small" @click.native="handleDel(scope.$index, scope.row.notification_id)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div style="margin-top: 30px">
            <el-button @click="toggleSelect(list)" size="mini">全选/反选</el-button>
            <el-button @click="deleteSelect" type="danger" size="mini">删除</el-button>
        </div>

        <el-pagination class="pagination-container"
            style="height:50px;"
            background
            :page-size="page_size"
            @current-change="handleCurrentChange"
            layout="total,prev, pager, next"
            :total="total"
            :current-page.sync="query.page">
        </el-pagination>


        <!--表单-->
        <el-dialog
                :title="formMap[formName]"
                :visible.sync="formVisible"
                :before-close="hideForm"
                width="50%"
                top="5vh"
        >
            <el-form :model="formData" label-position="left" :rules="formRules" ref="dataForm">
                <el-form-item label="标题：" prop="content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <el-input v-model="formData.title" placeholder="请输入标题" clearable style="width: 220px;"></el-input>
                </el-form-item>

                <!-- 2021 03 15 添加  新增判断 系统带文章id / 用户plus id    start -->
                <el-form-item label="推送类型：" prop="content">
                    <el-radio v-model="formData.send_type" :label="1">消息群发</el-radio>
                    <el-radio v-model="formData.send_type" :label="2">个人页面群发</el-radio>
                </el-form-item>

                <el-form-item label="文章ID：" prop="content" v-if="formData.send_type == 1">&nbsp;&nbsp;&nbsp;
                    <el-input v-model="formData.jump_find_id" placeholder="请输入文章ID" clearable style="width: 220px;"></el-input>
                </el-form-item>
                <el-form-item label="用户ID：" prop="content" v-if="formData.send_type == 2">&nbsp;&nbsp;&nbsp;
                    <el-input v-model="formData.jump_user_id" placeholder="请输入用户ID" clearable style="width: 220px;"></el-input>
                </el-form-item>
                <!-- 2021 03 15 添加  新增判断 系统带文章id / 用户plus id    end -->
                <el-form-item label="是否推送android：" prop="content">
                    <el-radio v-model="formData.send_android" :label="0">不发送</el-radio>
                    <el-radio v-model="formData.send_android" :label="1">发送</el-radio>
                    <span style="color:#888;font-size:12px">已发送Android数量:
                        <span style="font-weight: bold" >{{ androidtimes }} / 10</span>
                    </span>
                </el-form-item>



                <el-form-item class="query-form-item" label="推送时间：" size="">
                    <span class="demonstration"></span>
                    <el-date-picker
                        v-model="formData.notification_time"
                        type="datetime"
                        placeholder="推送时间"
                        >
                    </el-date-picker>
                </el-form-item>
                <el-form-item label="推送用户：" prop="content">
                    <el-select v-model="formData.system_type" clearable placeholder="请选择">
                        <el-option :value="0" label="全部用户"/>
                        <el-option :value="1" label="普通"/>
                        <!-- <el-option :value="2" label="异常"/> -->
                        <el-option :value="2" label="认证"/>
                        <el-option :value="3" label="Pro"/>
                    </el-select>
                </el-form-item>
                <el-form-item label="详情介绍：" prop="content">
                    <el-input type="textarea" v-model="formData.text" placeholder="详情介绍" clearable style="width: 500px;"></el-input>
                </el-form-item>
                <!-- <Tinymce ref="tinymce" v-model="formData.text"></Tinymce> -->
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button type="success" @click.native="formSubmit()" :loading="formLoading">提交</el-button>
                <el-button type="danger" @click.native="hideForm">取消</el-button>
            </div>
        </el-dialog>

    </div>

</template>

<script>
import Tinymce from "../../components/Tinymce/index";
import { messageList, messageSave, messageDelete } from "../../api/message/message";
import Upload from "../../components/File/Upload.vue";
const formJson = {
    send_type: 1,
    send_android: 1,


};
export default {
    // inject:['reload'],
    data() {
        return {
            lists:"",
            query: {
                name: "",
                page: 1,
                time:'',
                limit: 10,
                notification_id:''
            },
            channelListInput: "",
            androidVersionListInput: "",
            iosVersionListInput: "",
            list: [],
            total: 0,
            loading: true,
            index: null,
            formName: null,
            formMap: {
                add: "新增",
                edit: "编辑"
            },
            formLoading: false,
            formVisible: false,
            formVisibleSee: false,
            formData: formJson,
            androidtimes:0,
            formRules: {
                title: [
                    {
                        required: true,
                        message: "请输入标题",
                        trigger: "blur"
                    }
                ]
            },
            deleteLoading: false,
            multipleSelection:[]
        };
    },
    components: {
        Upload,
        Tinymce
    },
    comments: {
            Tinymce
        },
    methods: {
        //重置
        reset(){
            this.$router.push({
                path: ""
            });
            this.query = {
                title: "",
                page: 1,
                limit: 10
            };
            sessionStorage.setItem( "currentPage_messageList", 1);
            this.getList();
        },
        backHistory(){
            this.$router.go(-1);//返回上一层
        },
        toggleSelect(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row, !this.allSelect)
                })
                this.allSelect = !this.allSelect
            }
        },
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        // 删除选中的
        deleteSelect(){
            this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        var notification_id_arr = [];
                        this.multipleSelection.forEach(row => {
                            notification_id_arr.push(row.notification_id)
                        })
                        let para = { notification_id_arr: notification_id_arr };
                        this.deleteLoading = true;
                        messageDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code!==0) {
                                    this.$message.error(response.msg);
                                    return false;
                                } else {
                                    this.$message.success("删除成功");
                                    this.getList();
                                }
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
                        this.$message.info("取消删除");
                    });
        },
        // onReset() {
        //     this.$router.push({
        //         path: ""
        //     });
        //     this.query = {
        //         title: "",
        //         page: 1,
        //         limit: 20
        //     };
        //     this.getList();
        // },
        onSubmit() {
            this.$router.push({
                path: "",
                query: this.query
            });
            this.getList();
        },
        handleCurrentChange(val) {
            this.query.page = val;

            sessionStorage.setItem( "currentPage_messageList", val);

            this.getList();
        },

        getList() {
            this.loading = true;
            console.log('this.query.列表',this.query);
            messageList(this.query)
                .then(response => {
                    this.loading = false;
                    this.list = response.data.data || [];
                    this.total = response.data.total || 0;
                    this.androidtimes = response.data.androidtimes;
                })
                .catch(() => {
                    this.loading = false;
                    this.list = [];
                    this.total = 0;
                });
        },

        // 删除渠道
        handleChannelListClose(index) {
            // 更改值
            this.formData.channel_list.splice(index, 1);
        },
        // 添加渠道白名单
        handleChannelListSubmit() {
            // 更改值
            if (
                this.channelListInput &&
                this.formData.channel_list.length < 15
            ) {
                let arr = this.channelListInput.split(",");
                for (let i in arr) {
                    if (
                        arr[i] !== "" &&
                        (this.formData.channel_list.length === 0 ||
                            this.formData.channel_list.indexOf(arr[i]) < 0)
                    ) {
                        this.formData.channel_list.push(arr[i]);
                    }
                }
                this.channelListInput = "";
                this.$refs.channelListRef.focus();
            }
        },
        // 删除Android版本
        handleAndroidVersionListClose(index) {
            // 更改值
            this.formData.android_version_list.splice(index, 1);
        },
        // 添加Android版本
        handleAndroidVersionListSubmit() {
            // 更改值
            if (
                this.androidVersionListInput &&
                this.formData.android_version_list.length < 15
            ) {
                let arr = this.androidVersionListInput.split(",");
                for (let i in arr) {
                    let avList = this.formData.android_version_list;
                    if (
                        arr[i] !== "" &&
                        (avList.length === 0 || avList.indexOf(arr[i]) < 0)
                    ) {
                        this.formData.android_version_list.push(arr[i]);
                    }
                }
                this.androidVersionListInput = "";
                this.$refs.androidVersionListRef.focus();
            }
        },
        // 删除Ios版本
        handleIosVersionListClose(index) {
            // 更改值
            this.formData.ios_version_list.splice(index, 1);
        },
        // 添加Ios版本
        handleIosVersionListSubmit() {
            // 更改值
            if (
                this.iosVersionListInput &&
                this.formData.ios_version_list.length < 15
            ) {
                let arr = this.iosVersionListInput.split(",");
                for (let i in arr) {
                    if (
                        arr[i] !== "" &&
                        (this.formData.ios_version_list.length === 0 ||
                            this.formData.ios_version_list.indexOf(arr[i]) < 0)
                    ) {
                        this.formData.ios_version_list.push(arr[i]);
                    }
                }
                this.iosVersionListInput = "";
                this.$refs.iosVersionListRef.focus();
            }
        },
        // 刷新表单
        resetForm() {
            if (this.$refs["dataForm"]) {
                // 清空字段
                this.$refs["dataForm"].resetFields();
                // 清空验证信息表单
                this.$refs["dataForm"].clearValidate();
            }
        },
        // 隐藏表单
        hideForm() {
            // 更改值
            this.formVisible = !this.formVisible;
            // 清空表单
            this.$refs["dataForm"].resetFields();
            //清空富文本
            //this.$refs.tinymce.clearContent();
            let vm = this;
            setTimeout(function () {
                vm.$nextTick(() => {
                    if (vm.$refs.tinymce) {
                        vm.$refs.tinymce.setContent(
                            ''
                        );
                    }
                });
            }, 300);
        },
        // 显示表单
        handleForm(index, row) {
            console.log(row,'555555');
            this.formVisible = true;
            this.formData = Object.assign({}, formJson);
            if (row !== null) {
                this.formData = Object.assign({}, row);
            }
            this.formName = "add";
            //编辑
            if (index !== null) {
                this.imageUrl = row.img;
                this.index = index;
                this.formData.notification_id = row.notification_id;
                this.formData.jump_find_id = row.jump_id;
                this.formData.jump_user_id = row.jump_id;
                this.formData.send_type = row.send_type;
                this.formData.send_android = row.send_android;

                // if (this.formData.type == 8) {
                //     this.formData.send_type = 1
                // }
                // if (this.formData.type == 10) {
                //     this.formData.send_type = 2
                // }
                // console.log(this.formData,'this.formData');
                // return ;
                this.formName = "edit";
                let vm = this;
                setTimeout(function () {
                    vm.$nextTick(() => {
                        if (vm.$refs.tinymce) {
                            vm.$refs.tinymce.setContent(
                                row.content
                            );
                        }
                    });
                }, 500);
            }
            // 清空验证信息表单
            if (this.$refs["dataForm"]) {
                this.$refs["dataForm"].clearValidate();
            }
        },
        // 提交 -- 推送
        formSubmit() {
            this.$refs["dataForm"].validate(valid => {
                if (valid) {
                    this.formLoading = true;
                    this.formData.operation_type = this.formName; // 操作类型 add/save
                    // this.formData.operation_type = this.formName;

                    // 2021 03 15 添加  新增判断 系统带文章id / 用户plus id
                    if (this.formData.send_type == 1) {
                        this.formData.jump_id = this.formData.jump_find_id
                    }
                    if (this.formData.send_type == 2) {
                        this.formData.jump_id = this.formData.jump_user_id
                    }
                    let data = Object.assign({}, this.formData);

                    // console.log(this.formData,'this.formData');
                    // return ;

                    messageSave(data, this.formName)
                        .then(response => {

                            this.formLoading = false;
                            // console.log(response,'ssssssssssssssssssssss')
                            if (response.code!==0) {
                                this.$message.error(response.message);
                                return false;
                            }
                            this.$message.success("操作成功");
                            this.getList();
                            this.formVisible = false;
                            if (this.formName === "add") {
                                // 向头部添加数据
                                data.ad_id = response.data.ad_id;
                                this.list.unshift(data);
                            } else {
                                this.list.splice(this.index, 1, data);
                            }
                        })
                        .catch(() => {
                            this.formLoading = false;
                        });
                }
            });
        },
        handleFormSee(index,row) {
            console.log(row.notification_id);
            this.$router.push({
                path: "/messageManage/messageDetail",
                query: {
                    notification_id: row.notification_id
                }
            });
        },
        // 删除
        handleDel(index, row) {
            if (row) {
                this.$confirm("确认删除该记录吗?", "提示", {
                    type: "warning"
                })
                    .then(() => {
                        var notification_id_arr = [];
                        notification_id_arr.push(row)
                        let para = { notification_id_arr: notification_id_arr };
                        this.deleteLoading = true;
                        messageDelete(para)
                            .then(response => {
                                this.deleteLoading = false;
                                if (response.code != 0) {
                                    this.$message.error(response.message);
                                    return false;
                                } else {
                                    this.$message.success("删除成功");
                                    this.getList();
                                    // this.$router.go(0)
                                }
                            })
                            .catch(() => {
                                this.deleteLoading = false;
                            });
                    })
                    .catch(() => {
                        this.$message.info("取消删除");
                    });
            }
        },
        onSelectPic(filePath, filePathUrl) {
            this.formData.pic = filePath;
            this.formData.pic_url = filePathUrl;
        }
    },
    filters: {
        // statusFilterType(status) {
        //     const statusMap = {
        //         0: "gray",
        //         1: "success"
        //     };
        //     return statusMap[status];
        // },
        statusFilterName(status) {
            const statusMap = {
                0: "禁用",
                1: "正常"
            };
            return statusMap[status];
        },
        statusFilterType(status) {
            const statusMap = {
                1: "已推送",
                0: "未推送"
            };
            return statusMap[status];
        },
    },
    mounted() {},
    created() {
        // 将参数拷贝进查询对象
        let query = this.$route.query;
        this.query = Object.assign(this.query, query);
        this.query.limit = parseInt(this.query.limit);
        this.query.page = Number(sessionStorage.getItem("currentPage_messageList")) || 1;

        sessionStorage.setItem( "currentPage_advertList", 1);
        sessionStorage.setItem( "currentPage_findVideoList", 1);
        sessionStorage.setItem( "currentPage_findList", 1);
        sessionStorage.setItem( "currentPage_editorList", 1);
        sessionStorage.setItem( "currentPage_userList", 1);
        sessionStorage.setItem( "currentPage_normalUsersAdmin", 1);


        // 加载表格数据
        this.getList();
        var that = this;
        document.onkeydown = function(e) {
            var key = window.event.keyCode;
            if (key == 13) {
                that.getList();

            }
        }
    }
};
</script>

<style type="text/scss" lang="scss">
</style>
